import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { BoldButton } from '@bold/web-components-react';
import TypeformButtonWrapper from 'components/TypeformButtonWrapper';
import { getSearchParams, loopParamsSegment } from 'utils/search-params-functions';

import './styles.scss';

const HeroPro = ({ section }) => {
  const options = {
    id: 'WZfc8izq',
    opacity: 100,
    tracking: {
      ...loopParamsSegment(),
      ...{ type: 'web', page_name: 'datafono-smart-pro', section_name: section },
    },
  };

  const handleLink = () => {
    window.open(getSearchParams('https://datafonos.bold.co/smart-pro/'), '_blank', 'noopener noreferrer');
  };

  return (
    <section id="bold-smart-pro-hero" className="bold-smart-pro-hero">
      <div className="section-container">
        <div className="hero-wrapper hero-pro">
          <div className="show-mobile">
            <StaticImage src="./images/smart-pro-sm.webp" alt="" loading="lazy" fetchpriority="low" />
          </div>
          <div className="show-tablet">
            <StaticImage src="./images/smart-pro-md.webp" alt="" loading="lazy" fetchpriority="low" />
          </div>
          <div className="show-desktop">
            <StaticImage src="./images/smart-pro-xl.webp" alt="" loading="lazy" fetchpriority="low" />
          </div>
          <div className="wrapper">
            <div className="section-grid inner-container">
              <div className="info">
                <div className="heading">
                  <h2>SMART PRO</h2>
                  <span>Pre-lanzamiento</span>
                </div>
                <div className="content">
                  <p className="feature">Más ventas.</p>
                  <p className="feature">Más métodos de pago.</p>
                  <p className="feature">Ahora con impresora.</p>
                  <p className="sub-title">Pro-evoluciona la forma de cobrar en tu negocio</p>
                  <ul>
                    <li>Mucho más rápido y fácil de usar</li>
                    <li>Recibe pagos con tarjeta, Nequi y crea links de pago</li>
                    <li>Reportes y conciliaciones sin enredos ni descuadres</li>
                  </ul>
                  <TypeformButtonWrapper options={options}>
                    <BoldButton>Unirme a la lista de espera</BoldButton>
                  </TypeformButtonWrapper>
                  <BoldButton outlined onClick={handleLink}>
                    Conocer más
                  </BoldButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroPro;
